<template lang="pug">
	img.publisher-logo(:src="Publisher.getLogoUrl(Publisher.SelectedPublisher)" v-if="Publisher.SelectedPublisher" :alt="Publisher.SelectedPublisher.title")
</template>

<script>

	import Screen from './../../mixins/screen'

	import { Publisher } from './../../services/Publisher'
	import { User } from './../../services/User'

	export default {
		name: "PublisherLogo",
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Publishers Changed", "Selected Publisher Changed"]
		},
		data() {
			this.Publisher = Publisher;
			this.User = User;

			let params = location.search.substr(1).split('&');
			params = _.mapKeys(params, v => v.split('=')[0]);
			params = _.mapValues(params, v => v.split('=')[1]);

			this.logo = params['logo'];

			return {
				showed: true
			}
		},
		methods: {

		}
	}
</script>

<style lang="sass" scoped>

	.publisher-logo
		display: flex
		height: 70%
		margin: 0 10px
		align-items: center
		color: #fff
		padding-left: 10px
		text-transform: uppercase
		image-rendering: -webkit-optimize-contrast

</style>

